export const rorDataSources = [
  {
    title: 'RoR Platform - VEE for G5 technology',
    content: `RoR stands for Review of Records, is the process of communicating with customers by addressing their questions. The RoR data of G5 projects can be easily accessible through Akira platform. The ultimate objective is to enable engineers to efficiently retrieve RoR responses from the G5 projects, providing a reliable reference to support the ongoing RoR activities instead of manual searches within xECM.`,
    sourceSystem: null,
    prompts: [
      'How to calculate the maximum junction temperature of BIGT?',
      'Provide the document Id of the valve design report of Adani Mumbai project?',
      'What design measures can prevent coolant leaks in valve structures?'
    ],
    datasourcelink: ''
  }
]
